export function detectMob() {
    return ((window.innerWidth <= 700));
}

export function getScreenWidth() {
    return (window.innerWidth);
}